import { theme } from 'lib/theme';
import React from 'react';
import { CardRow } from './CardRow';

type CardRowProps = {
  label: string;
};

export const CardRowTitle: React.FC<CardRowProps> = ({ label }) => {
  return (
    <CardRow
      label={label}
      labelSize="xsmall"
      labelWeight="bold"
      labelStyle={{ paddingTop: 0, marginTop: 0 }}
      style={{
        minHeight: 0,
      }}
      contentStyle={{
        paddingTop: theme.paddingHorizontalHalf,
        paddingBottom: theme.paddingHorizontalHalf,
      }}
      compact
    />
  );
};
